r
<template>
  <v-dialog v-model="showDialog" max-width="600px">
    <v-card>
      <v-toolbar dark color="secondary">
        <v-card-title class="headline">Event Attendees</v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="showDialog = false" icon>
          <i class="fas fa-times"></i>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-data-table :items="attendees" :headers="headers">
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EventAttendeesDialog',
  computed: {
    showDialog: {
      get() {
        return this.$store.state.events.showEventAttendeesDialog;
      },
      set(value) {
        if (!value) {
          this.$store.dispatch('events/setAttendeesState', []);
        }
        this.$store.dispatch('events/setEventAttendeesDialogState', value);
      },
    },
    attendees() {
      return this.$store.state.events.attendees;
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'assignee.name',
        },
        {
          text: 'Email',
          value: 'assignee.email',
        },
        {
          text: 'Phone Number',
          value: 'assignee.phone_number',
        },
      ],
    };
  },
};
</script>

<style scoped></style>
